import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export default function Ribbon() {
  const { t } = useLang();
  const words = t.marquee.split("·").map((w) => w.trim()).filter(Boolean);

  return (
    <div className="border-y border-ink/10 bg-cream-2 py-6" data-testid="marquee">
      <Marquee speed={38} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center font-serif italic text-2xl md:text-4xl text-ink px-6">
            {w}
            <span className="mx-6 text-brand not-italic">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
